<common-mojo-profile-card
  [avatar]="avatarContent"
  [text]="textContent"
>
  <mojo-candidate-badges
    badges
    [favorite]="candidate?.favorite"
    [silver]="candidate?.silver"
    [alumni]="candidate?.alumni"
    [warning]="candidate?.warning"
  >
  </mojo-candidate-badges>
  <mojo-dropdown-menu-with-icons
    [menuItems]="menuItems"
    [targetId]="candidate.id"
    button-on-top-of-avatar
  >
  </mojo-dropdown-menu-with-icons>
  <mojo-candidate-badges-popover
    mojo-card-buttons-row-first
    [candidate]="candidate"
    [isFullBadges]="isFullBadges$ | async"
    *mojoHasPrivilege="candidatePrivileges.candidates.badges"
  >
  </mojo-candidate-badges-popover>

  <a
    mojo-card-buttons-row-second
    [routerLink]="['', { outlets: { modal: ['candidateForm', candidate?.id] } }]"
    *mojoHasPrivilege="privileges.candidates.edit"
  >
    <mat-icon>edit</mat-icon>
  </a>

  <mojo-candidate-contact
    mojo-card-fourth-row
    [verticalLayout]="true"
    [candidate]="candidate"
    [candidateCard]="true"
    [includeResumeButton]="false"
  ></mojo-candidate-contact>

  <mojo-social-links
    mojo-card-fifth-row
    [candidate]="candidate"
    [includeContactButtons]="false"
    [includeResumeButton]="true"
  >
    <mojo-ats-button
      class="candidate-profile-ats-btn"
      [type]="candidateAtsButtonType"
      [entity]="candidate"
    >
    </mojo-ats-button>
  </mojo-social-links>

</common-mojo-profile-card>
